// extracted by mini-css-extract-plugin
export default {"error":"Context_error__Hk-jy","success":"Context_success__U0KvS","notification":"Context_notification__YG4RP","notifications":"Context_notifications__R7cwA"};